export class OrganisationAttributeModel {
    public organisationAttributeId: string
    public organisationId: string;
    public organisationAttributeTypeCode: string;
    public organisationAttributeChoiceId: string;
    public organisationAttributeValue: number;
    public attributeText: string;
    public attributeDateTime: Date;
    public conditionCode: string;
    public excludeFlag: boolean;
    public displaySequence: number;
    public attributeChoiceName: string;
    public attributeChoiceCode: string;
    public attributeGroupCode: string;
}